/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import React, { ReactNode, Suspense, useEffect } from "react";
import Wrapper from "../component/Wrapper";
import Main from "../component/Main";

import Content from "../component/Content";
import Loader from "../component/Loader";
import { Outlet } from "react-router-dom";
import Navbar from "../component/navbar/Navbar";
import Sidebar from "../component/sidebar/Sidebar";
import { SidebarItemsType } from "../types/sidebar";
import {
	ShoppingCart,
    Wrench,
    Barcode,
} from "lucide-react";
import Footer from "../component/Footer";

interface DashboardProps {
  children?: ReactNode;
}

export const Digicape: React.FC<DashboardProps> = ({ children }) => {
    
    // Credentials
    const credentials = `${'g'}:${'p'}`; // TODO - Needs to come out of here.

    const fetchData = async (url: string, options: { method: string; headers?: HeadersInit; body?: string }, processData?: any) => {
        
        const response = await fetch(url, options);
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    
        const responseJson = await response.json();
        processData(responseJson);
          
    };

    const appSection = [
        {
            href: "/dpp",
            icon: Barcode,
            title: "DPP",
            children: [
                {
                    href: "/dpp/claims",
                    title: "Claims",
                },
                {
                    href: "/dpp/devices",
                    title: "Devices",
                },
                {
                    href: "/dpp/dpps",
                    title: "DPP",
                }
            ],
        },        
        {
            href: "/ecommerce",
            icon: ShoppingCart,
            title: "Ecommerce",
            children: [
                // {
                //     href: "/ecommerce/dash",
                //     title: "Dashboard",
                //     // badge: "New"
                // }, 
                // {
                //     href: "/ecommerce/attribute",
                //     title: "Attribute",
                // },
                // {
                //     href: "/ecommerce/attribute-term",
                //     title: "Attribute Term",
                // },
                // {
                //     href: "/ecommerce/category",
                //     title: "Category",
                // },
                // {
                //     href: "/ecommerce/item",
                //     title: "Item",
                // },
                // {
                //     href: "/ecommerce/item-asset",
                //     title: "Item Asset",
                // },
                // {
                //     href: "/ecommerce/item-attribute",
                //     title: "Item Attribute",
                // },
                // {
                //     href: "/ecommerce/item-attribute-term",
                //     title: "Item Attribute Term",
                // },
                // {
                //     href: "/ecommerce/item-category",
                //     title: "Item Category",
                // },

                {
                    href: "/ecommerce/collections",
                    title: "Collections",
                },                
                {
                    href: "/ecommerce/products",
                    title: "Product",
                },               
                {
                    href: "/ecommerce/product-varieties",
                    title: "Product Varieties",
                },                
                {
                    href: "/ecommerce/transfers",
                    title: "Transfers",
                },
                {
                    href: "/ecommerce/gift-cards",
                    title: "Gift Cards",
                },
                {
                    href: "/ecommerce/catalogs",
                    title: "Catalogs",
                },  
            ],
        },
        {
            href: "/fixably",
            icon: Wrench,
            title: "Fixably",
            children: [
                {
                    href: "/fixably/customer-master",
                    title: "Customer Master",
                },
                {
                    href: "/fixably/stock-master",
                    title: "Stock Master",
                },
                // {
                //     href: "/fixably/purchase-invoices",
                //     title: "Purchase Invoices",
                // },
                {
                    href: "/fixably/purchase-orders",
                    title: "Purchase Orders",
                },
                {
                    href: "/fixably/sales-invoices",
                    title: "Sales Invoices",
                },
                // {
                //     href: "/fixably/notifications",
                //     title: "Notifications",
                // }, 
                {
                    href: "/fixably/notifications",
                    title: "Error Notifications",
                },                                
            ],
        }
    ] as unknown as SidebarItemsType[];

    const navItems = [
        {
            title: "Channel Application Data:",
            pages: appSection,
        }
    ];

    return (
    
        <React.Fragment>
            <Wrapper>
                <Sidebar items={navItems} />
                <Main>
                    <Navbar />
                    {/* <Body /> */}
                    <Content>
                        <Suspense fallback={<Loader />}>
                            {children}
                            <Outlet />
                        </Suspense>
                    </Content>
                    <Footer />
                </Main>
            </Wrapper>       
        </React.Fragment>
    )
};
